import { render, staticRenderFns } from "./ViStudentView.vue?vue&type=template&id=298d6df2"
import script from "./ViStudentView.vue?vue&type=script&lang=js"
export * from "./ViStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports